import React, { useEffect } from 'react';
import { Box, Modal, Snackbar, TextField, Grid, Stack } from '@mui/material';
import tagService from '../../../../services/api/insights/tagService';
import { AppButton } from '../../../../resources/styling';
import { colors } from '../../../../resources/theme/colors';
import Alert from '@mui/material/Alert';
import { OutlineButton } from '../../../../resources/styling/appStyle';
import surveyTagService from '../../../../services/api/insights/surveyTagService';
import { set } from 'lodash';

const { mandy, pictonBlue } = colors;

export default function AddEditTag({
  selectedTag,
  editTagDone,
  mode,
  openEdit,
  setSelectedTag,
}) {
  const [tag, setTag] = React.useState(selectedTag);
  const [status, setStatus] = React.useState({
    open: false,
    message: '',
    type: 'success',
  });

  useEffect(() => {
    setTag(selectedTag);
  }, [selectedTag]);

  const handleSave = () => {
    if (mode === 'edit') {
      surveyTagService.putTag({ ...tag }).then((res) => {
        setStatus({
          open: true,
          message: 'Tag updated successfully',
          type: 'success',
        });
        editTagDone('done', res);
      });
    } else {
      surveyTagService.postTag({ ...tag }).then((res) => {
        setStatus({
          open: true,
          message: 'Tag created successfully',
          type: 'success',
        });

        editTagDone('done', res);
      });
    }
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        variant='filled'
        open={status.open}
        autoHideDuration={5000}
        onClose={() => setStatus({ ...status, open: false })}
      >
        <Alert severity={status.type} sx={{ width: '100%' }} variant='filled'>
          {status.message}
        </Alert>
      </Snackbar>
      <Modal open={openEdit} onClose={() => editTagDone('cancel')}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            width: 400,
            p: 3,
          }}
        >
          <Grid container rowSpacing={1.5}>
            <Grid item xs={12} lg={12} md={12} sm={12}>
              <h2>{mode === 'edit' ? 'Edit Tag' : 'Add Tag'}</h2>
            </Grid>
            <Grid item xs={12} lg={12} md={12} sm={12}>
              <TextField
                label='Tag'
                value={tag?.tag}
                fullWidth
                onChange={(e) => {
                  setTag({ ...selectedTag, tag: e.target.value });
                  if (mode === 'edit') {
                    setSelectedTag({ ...selectedTag, tag: e.target.value });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} lg={12} md={12} sm={12}>
              <Stack direction='row' gap={1} justifyContent='flex-end'>
                <OutlineButton
                  onClick={() => editTagDone('cancel')}
                  sx={{ marginRight: 2 }}
                >
                  Cancel
                </OutlineButton>
                <AppButton
                  color={mandy}
                  onClick={handleSave}
                  sx={{ marginRight: 2 }}
                >
                  Save
                </AppButton>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}
